import PropTypes from 'prop-types';

import Heading from '@zenbusiness/zui/Heading';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { formatName, formatPhoneNumber } from '#client/utils/formatString';

import * as Styled from '../../AccountSettings.style';

const fields = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'phone',
    label: 'Phone',
  },
  {
    key: 'email',
    label: 'Email',
  },
  {
    key: 'password',
    label: 'Password',
  },
];

const AccountHolder = ({
  account: { firstName, middleName, lastName, suffix, accountEmail: email, accountPhone: phone } = {},
  isSocialLogin,
  loading,
  onClickEdit,
}) => {
  const account = {
    name: formatName(firstName, middleName, lastName, suffix),
    phone: formatPhoneNumber(phone),
    email,
    password: 'Manage Password',
  };

  const renderListItemContent = (key) => {
    if (loading) {
      return <Skeleton height="28px" width="80%" />;
    }

    if (key === 'password') {
      return (
        <Styled.ButtonLink onClick={onClickEdit} size="md" variant="text" color="info" sx={{ padding: 0 }}>
          {account[key]}
        </Styled.ButtonLink>
      );
    }

    return (
      <Text component="p" size="md" color="primary" sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
        {account[key]}
      </Text>
    );
  };

  return (
    <Stack gap={{ xs: 3, sm: 4 }}>
      <Heading component="h2" size="lg">
        General Info
      </Heading>
      <Styled.ListInfo>
        {fields.map(({ key, label }) => {
          if (isSocialLogin && key === 'password') {
            return null;
          }

          return (
            <Styled.InfoItem key={key}>
              <Text component="p" size="xs" weight="regular" sx={{ textTransform: 'uppercase' }} color="secondary">
                {label}
              </Text>
              {renderListItemContent(key)}
            </Styled.InfoItem>
          );
        })}
      </Styled.ListInfo>
    </Stack>
  );
};

AccountHolder.propTypes = {
  account: PropTypes.shape({}).isRequired,
  isSocialLogin: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClickEdit: PropTypes.func.isRequired,
};

export default AccountHolder;
